import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PermissionService from "services/PermissionService";

export const getAllPermission = createAsyncThunk(
  "Permission/getAllPermission",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PermissionService.getAllPermission(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  permissionList: [],
};
export const storePermissionSlice = createSlice({
  name: "Permission",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setPermission: (state, action) => {
      state.permissionList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPermission.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPermission.fulfilled, (state, action) => {
        state.loading = false;
        state.permissionList = action.payload;
      })
      .addCase(getAllPermission.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setPermission } = storePermissionSlice.actions;

export default storePermissionSlice.reducer;
